import { Component } from '@verndale/core';
import { sameOrigin } from '../helpers';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $tables: this.el._$$('table'),
      $links: this.el._$$('a')
    }

    this.dom.$tables.forEach(table => {
      table.outerHTML = `<div class='rtf__table-wrapper'>${table.outerHTML}</div>`;
    });

    this.dom.$links.forEach(link => {
      const href = link.getAttribute('href');
      if (href && !sameOrigin(href)) link.classList.add('link--external');
    });
  }
}

export default Module;
